// ============================================
// LATTH SAAB - PREMIUM HINDI NEWS PORTAL THEME
// ============================================

export const COLORS = {
  orange: '#8B5E34',
  yellow: '#C7A06C',
  deepBlack: '#2F2418',
  darkSurface: '#F8F4EE',
  red: '#A05A2C',
  white: '#FFFFFF',
  lightGray: '#F7F2EA',
  mediumGray: '#EEE5DB',
  darkGray: '#65584A',
  textMuted: '#7B6A58',

  primary: '#8B5E34',
  secondary: '#A05A2C',
  accent: '#C7A06C',
  success: '#4F7A52',
  warning: '#B77932',
  danger: '#A24D38',

  bgPrimary: '#FFFFFF',
  bgSecondary: '#FFFFFF',
  bgTertiary: '#F8F4EE',
  bgDark: '#FFFFFF',
  bgDarkCard: '#FFFFFF',

  orangeLight: 'rgba(139, 94, 52, 0.1)',
  redLight: 'rgba(160, 90, 44, 0.1)',
  yellowLight: 'rgba(199, 160, 108, 0.14)',
};

export const DEFAULT_THEME_SETTINGS = {
  primary: COLORS.primary,
  primaryDark: '#6B4726',
  primaryLight: '#B88A5C',
  secondary: COLORS.secondary,
  secondaryDark: '#7D4320',
  secondaryLight: '#C68458',
  accent: COLORS.accent,
  accentLight: '#E6D0B3',
  bgPrimary: COLORS.bgPrimary,
  bgSecondary: COLORS.bgSecondary,
  bgTertiary: COLORS.bgTertiary,
  textPrimary: COLORS.deepBlack,
  textSecondary: '#65584A',
  textTertiary: '#9B8A77',
  success: COLORS.success,
  warning: COLORS.warning,
  danger: COLORS.danger,
  info: '#5F7C8C'
};

export const GRADIENTS = {
  hero: 'linear-gradient(135deg, #FFFFFF 0%, #F8F4EE 100%)',
  heroOverlay: 'linear-gradient(180deg, rgba(139, 94, 52, 0.04) 0%, rgba(199, 160, 108, 0.1) 100%)',
  ctaBanner: 'linear-gradient(135deg, #8B5E34 0%, #A05A2C 100%)',
  cardHover: 'linear-gradient(180deg, #FFFFFF 0%, #F8F4EE 100%)',
  premium: 'linear-gradient(135deg, #8B5E34, #A05A2C, #C7A06C)',
  sectionBg: 'linear-gradient(180deg, #FFFFFF 0%, #F8F4EE 100%)',
};

export const TYPOGRAPHY = {
  fontFamily: "'Noto Sans Devanagari', 'Poppins', sans-serif",
  fontFamilyEn: "'Poppins', sans-serif",
  fontFamilyHi: "'Noto Sans Devanagari', sans-serif",

  // Font Sizes
  h1: '3.5rem',      // Hero headlines
  h2: '2.5rem',      // Section titles
  h3: '1.8rem',      // Card titles
  h4: '1.4rem',      // Subsections
  h5: '1.1rem',      // Labels
  h6: '0.95rem',     // Small text
  body: '1rem',
  small: '0.875rem',
  tiny: '0.75rem',

  // Font Weights
  thin: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,

  // Line Heights
  tight: 1.2,
  normal: 1.5,
  relaxed: 1.7,
  loose: 1.9,
};

export const SPACING = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  xxl: '32px',
  xxxl: '48px',
  huge: '64px',
};

export const RADIUS = {
  sm: '6px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  circle: '50%',
};

export const SHADOWS = {
  sm: '0 2px 8px rgba(0, 0, 0, 0.08)',
  md: '0 4px 16px rgba(0, 0, 0, 0.12)',
  lg: '0 8px 24px rgba(0, 0, 0, 0.15)',
  xl: '0 12px 32px rgba(0, 0, 0, 0.18)',
  xxl: '0 16px 48px rgba(0, 0, 0, 0.22)',
  hover: '0 10px 30px rgba(255, 153, 51, 0.25)',
  inset: 'inset 0 2px 8px rgba(0, 0, 0, 0.08)',
};

export const TRANSITIONS = {
  fast: '0.25s ease',
  normal: '0.35s ease',
  slow: '0.5s ease',
  slower: '0.75s ease',
  smoothCubic: '0.4s cubic-bezier(0.23, 1, 0.320, 1)',
};

export const BREAKPOINTS = {
  xs: '0px',
  sm: '480px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  xxl: '1536px',
};

export const Z_INDEX = {
  dropdown: 100,
  sticky: 200,
  fixed: 300,
  modal: 400,
  popover: 500,
  tooltip: 600,
};

// Hindi Content Strings
export const HINDI_STRINGS = {
  home: 'होम',
  district: 'जिला',
  block: 'ब्लॉक',
  videos: 'वीडियो',
  team: 'टीम',
  contact: 'संपर्क',
  breakingNews: '🔴 ब्रेकिंग न्यूज़',
  readMore: 'पूरी खबर पढ़ें',
  trendingNews: 'ट्रेंडिंग खबरें',
  advertisement: 'विज्ञापन',
  joinWhatsApp: 'व्हाट्सएप चैनल जॉइन करें',
  blockSection: 'चित्रकूट के ब्लॉक',
  viewMore: 'और देखें',
  videoNews: 'वीडियो समाचार',
  ourTeam: 'हमारी टीम',
  viewFullTeam: 'पूरी टीम देखें',
  joinUs: 'हमसे जुड़ें या सुझाव दें',
  aboutUs: 'संक्षिप्त परिचय',
  quickLinks: 'त्वरित लिंक',
  privacyPolicy: 'गोपनीयता नीति',
  copyright: '© २०२६ लठ्ठ साब। सर्वाधिकार सुरक्षित।',
};
